import { render } from "./client_services_management.html?vue&type=template&id=ee366264&external"
import script from "./client_services_management.js?vue&type=script&lang=js&external"
export * from "./client_services_management.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__